import { render, staticRenderFns } from "./LinksMenu.vue?vue&type=template&id=c2806086&scoped=true"
import script from "./LinksMenu.vue?vue&type=script&lang=js"
export * from "./LinksMenu.vue?vue&type=script&lang=js"
import style0 from "./LinksMenu.vue?vue&type=style&index=0&id=c2806086&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2806086",
  null
  
)

export default component.exports